import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { IGetReviewsResponse } from "../../types";
import { ReviewService } from "../../../services/review.service";

type Params = { gymListingId: string; pageSize?: number; page: number };

export const useGetAllReviewsByGymIdQuery = ({ gymListingId, pageSize = 2, page }: Params) => {
  return useQuery<IGetReviewsResponse, Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_REVIEWS, gymListingId, page, pageSize],
    enabled: !!gymListingId,
    queryFn: () =>
      ReviewService.getAll({
        currentPage: page,
        pageSize,
        gymListingId,
      }),
    staleTime: 60_000,
  });
};
